"use client";

import SignUpForm from "@/components/auth/sign-up-form";

export default function SignUp() {
  return <SignUpForm />;
}
